import {
    
    TextField, TextFieldProps,
} from "@mui/material";
import {  styled} from "@mui/material/styles";
import * as React from "react";

const validColor = '#28a745';
const errorColor = '#dc3545';
const InputField = styled(TextField)(({theme}) => ({
    margin:'12px 0 0 0',
    '& .MuiInputLabel-root':{
        position: 'initial',
        textAlign: 'left',
        transform: 'none',
        color: theme.palette.text.primary,
        '&& + *': {
            // override initial styles
            // label + .MuiInput-formControl
            marginTop: 8,
        },
    },
    '& .MuiInputLabel-root.Mui-disabled':{
        color:' rgba(0, 0, 0, 0.38)'
    },
    
    '& .MuiInputBase-input': {
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        
        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
        '&:focus': {
            outline: 'none',
        }
    },
    '& .MuiInputBase-root .MuiInputBase-input.MuiOutlinedInput-input::placeholder': {
        opacity:'0.42 !important'
    },
    '& .MuiInputBase-input.MuiInputBase-inputAdornedStart':{
        borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
        paddingLeft:8
    },
    '& .MuiInputBase-input.MuiInputBase-inputAdornedEnd':{
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
        paddingLeft:8
    },
    '& .MuiFormHelperText-root.Mui-error':{
        marginLeft:0
    },
    '& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root': {
        padding:0,
        '&& + *': {
            marginTop: 8,
        },
        '& .MuiOutlinedInput-notchedOutline > legend':{
            display:'none'
        },
        '& .MuiOutlinedInput-notchedOutline':{
           top:0
        },
        '& .MuiAutocomplete-input' :{
            padding: '8.5px 14px'
        }
    },
   
}));

const TextInput = React.forwardRef((props: TextFieldProps,ref) =>{
    return (<InputField ref={ref as unknown as React.RefObject<HTMLDivElement>} size={"small"} InputLabelProps={{shrink:false}} {...props} />)
});



export default TextInput;